import { LearningRecommendationsService } from '@/services/learningRecommendation'
import { ApiErrorResponse, ApiIndividualResponse } from '@/types/api'
import { IRecommendation } from '@/types/recommendations'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

export type UseLearningRecommendationOptions = {
  id: string
  queryOptions?: Omit<
    UseQueryOptions<
      ApiIndividualResponse<IRecommendation>,
      ApiErrorResponse,
      ApiIndividualResponse<IRecommendation>
    >,
    'queryKey' | 'queryFn'
  >
}

export const useLearningRecommendation = ({
  id,
  queryOptions = {},
}: UseLearningRecommendationOptions) => {
  return useQuery({
    queryKey: ['learning-recommendations', id],
    queryFn: () =>
      LearningRecommendationsService.getLearningRecommendationById(id),
    ...queryOptions,
  })
}
